"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionsByCookbookIdQuery = void 0;
const client_1 = require("@apollo/client");
const sectionAndRecipeName_1 = require("../fragments/sectionAndRecipeName");
exports.sectionsByCookbookIdQuery = client_1.gql `
  query SectionsByCookbookId($cookbookId: String!) {
    sectionsByCookbookId(cookbookId: $cookbookId) {
      ...justSection
    }
  }
  ${sectionAndRecipeName_1.justSectionFragment}
`;
//# sourceMappingURL=sectionsByCookbookId.js.map